/*----- Imports -----*/
import React              from 'react'
import styled             from 'styled-components'

/*----- Assets -----*/
import InstagramIcon from  '../../../assets/icons/social_network/instagram.svg'
import FacebookIcon  from  '../../../assets/icons/social_network/facebook.svg'
import WhatsappIcon  from  '../../../assets/icons/social_network/whatsapp.svg'
import EmailIcon     from  '../../../assets/icons/email.svg'
import SNNlogo       from  '../../../assets/logos/ssn.svg'

/*----- Ant design -----*/
import { Row, Col } from 'antd'

/*----- Commmons -----*/
import Montserrat from '../../../commons/mixins/fonts/Montserrat'

/*----- Components -----*/
import AsideMenu        from '../../commons/nav/AsideMenu'
import SectionContainer from '../../commons/SectionContainer'
import Title            from '../../text/Title'
import Device           from '../../../commons/Device'
import Paragraph        from '../../text/Paragraph'
import IntivaFooter from './IntivaFooter'

/*----- Styles -----*/
const StyledFooter = styled.footer`
	padding: 32px 0;
	.app-footer__first-section {
		padding-right: 16px;
	}
	.app-footer__firs-section {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.app-footer__second-section {
		margin: 32px 0;
	}
	.app-footer__social-network {
		display: flex;
    align-items: center;
		margin-top: 64px;
		/*** Overwrite ***/
		.custom-title, .custom-paragraph {
			margin: 0;
		}
	}
	.app-footer__social-item-container {
		display: flex;
		flex-direction: column;
		margin-bottom: 32px;
	}
	.app-footer__social-network__data-container {
		padding-left: 32px;
	}
	.app-footer__social-item {
    display: flex;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    padding: 16px;
    justify-content: center;
    align-items: center;
		&:first-child {
			margin-left: 0;
		}
    .icon {
      width: 50px;
    }
  }
	.app-footer__greeting__title {
		${ Montserrat(50, 600,'Black') };
		text-transform: uppercase;
		line-height: 50px;
	}
	.app-footer__greeting__subtitle {
		${ Montserrat(18, 600,'Black') };
		text-transform: uppercase;
		max-width: 320px;
    line-height: 24px;
    letter-spacing: 10px;
		margin: 32px 0;
	}
	.app-footer__invitation {
		max-width: 300px;
	}
	.app-footer__legal {
		margin-top: 32px;
		p { font-size: 12px}
	}
	.ssn {
		display: flex;
		img {
			width: 90px;
			margin: -4px 16px 0 16px;
		}
		p {
			margin: 0;
			line-height: 12px;
			font-size: 10px;
		}
	}
	.contact-item__container {
		display: flex;
		img {
			width: 40px;
			height: intrinsic;
		}
		.custom-paragraph {
			margin-left: 16px;
			line-height: 20px;
		}
	}
	/*** Media queries ***/
	@media ${ Device.lg } {
		.app-footer__second-section {
			padding: 32px 0 32px 64px;
			border-left: 1px solid grey;
		}
		.app-footer__social-item-container {
			flex-direction: row;
		}
		.app-footer__social-network {
			&:nth-child(2) {
				margin-left: 40px;
			}
		}
	}
`

/*----- Component -----*/
const Footer = () => {
	return(
		<StyledFooter className="app-footer">
			<SectionContainer>
				<Row type="flex" justify="start" align="top">

					{/*** FIRST SECTION ***/}
					<Col xs={24} sm={{span: 24}} md={{span: 24}} lg={{span: 12 }} xl={{span: 10 }}>
						<div className="app-footer__first-section">
							<div className="app-footer__greeting">
								<h2 className="app-footer__greeting__title">Hola!</h2>
								<h3 className="app-footer__greeting__subtitle">¿Querés formar parte de la organización?</h3>
							</div>
						</div>
					</Col>

					{/*** SECOND SECTION ***/}
					<Col xs={24} sm={{span: 24}} md={{span: 24}} lg={{span: 12 }} xl={{span: 10 }}>
						<div className="app-footer__invitation">
							<div className="contact-item__container" style={{maxWidth: 280}}>
								<img src={ WhatsappIcon } className="icon"  alt="whatspp icon"/>
								<Paragraph content="Envianos un WhatsApp 221 572-4737" bold={true}/>
							</div>
							<div className="contact-item__container">
								<img src={ EmailIcon } className="icon"  alt="whatspp icon"/>
								<Paragraph content="Escribinos a contacto@organizacionlb.com.ar" bold={true}/>
							</div>
							<Paragraph content="¡Un miembro de nuestro equipo te brindará asesoramiento!"/>
						</div>
					</Col>
				</Row>

				{/*** SOCIAL NETWORKS ***/}
				<Row>
					<Col span={24}>
						<div className="app-footer__social-item-container">
							<div className="app-footer__social-network">
								<a href="https://www.instagram.com/OrganizacionLB" target="blank" className="app-footer__social-item">
									<img src={ InstagramIcon } className="icon"  alt="instagram icon"/>
								</a>
								<div className="app-footer__social-network__data-container">
									<Title content="Seguinos en Instagram" size={5} />
									<a href="https://www.instagram.com/OrganizacionLB" target="blank">
										<Paragraph content="/OrganizacionLB"/>
									</a>
								</div>
							</div>
							<div className="app-footer__social-network">
								<a href="https://www.facebook.com/organizacionluduenabernasconi" target="blank" className="app-footer__social-item">
									<img src={ FacebookIcon } className="icon"  alt="whatspp icon"/>
								</a>
								<div className="app-footer__social-network__data-container">
									<Title content="Seguinos en Facebook" size={5} />
									<a href="https://www.facebook.com/organizacionluduenabernasconi" target="blank">
										<Paragraph content="/organizacionluduenabernasconi"/>
									</a>
								</div>
							</div>
						</div>
					</Col>
				</Row>
			</SectionContainer>

			<Row className="ssn" type="flex" justify="center">
				<img src={ SNNlogo } className="icon"  alt="snn logo"/>
				<div>
					<Paragraph content="Nº Inscripción en SSN 726" />
					<Paragraph content="Atención al asegurado 0800-666-8400" />
					<Paragraph content="Organismo de control www.argentina.gov.ar/ssn" />
				</div>
			</Row>

			<Row type="flex" justify="center" className="app-footer__legal">
				<Paragraph content={ `| © Organización Ludueña Bernasconi ${new Date().getFullYear()} - Todos los derechos reservados |`} />
			</Row>

			<Row>
				<AsideMenu />
			</Row>

			<Row>
				<IntivaFooter />
			</Row>

		</StyledFooter>
	)
}

export default Footer